import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ExternalLinkState {
  url: string | null;
  title: string | null;
}

const initialState: ExternalLinkState = {
  url: null,
  title: null,
};

const externalLinkSlice = createSlice({
  name: 'externalLink',
  initialState,
  reducers: {
    setExternalLink: (state, action: PayloadAction<{ url: string; title: string }>) => {
      state.url = action.payload.url;
      state.title = action.payload.title;
    },
    clearExternalLink: (state) => {
      state.url = null;
      state.title = null;
    },
  },
});

export const { setExternalLink, clearExternalLink } = externalLinkSlice.actions;
export const ExternalLinkReducer = externalLinkSlice.reducer;

